"use strict";

exports.__esModule = true;
exports.WideRow = exports.StyledRadioGroup = exports.ScrollAbleElements = exports.Row = void 0;
var _Theme = require("../../Theme");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Row = exports.Row = _styledComponents["default"].div.withConfig({
  displayName: "styles__Row",
  componentId: "sc-kkdpju-0"
})(["display:flex;flex-direction:row;align-items:center;& > *{margin-right:10px;}"]);
var WideRow = exports.WideRow = _styledComponents["default"].div.withConfig({
  displayName: "styles__WideRow",
  componentId: "sc-kkdpju-1"
})(["padding-left:20px;display:flex;flex-direction:row;width:100%;align-items:center;justify-content:space-between;& > :last-child{width:85%;}"]);
var StyledRadioGroup = exports.StyledRadioGroup = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledRadioGroup",
  componentId: "sc-kkdpju-2"
})(["padding-top:10px;display:flex;padding-left:20px;"]);
var ScrollAbleElements = exports.ScrollAbleElements = _styledComponents["default"].div.withConfig({
  displayName: "styles__ScrollAbleElements",
  componentId: "sc-kkdpju-3"
})(["overflow-y:auto;position:relative;height:calc( 100vh - ", " - ", " - 100px );"], (0, _Theme.val)("NavbarHeight"), (0, _Theme.val)("ToolbarHeight"));